import CustomDropdown from '../../../components/common/CustomDropdown';
import {
  bankTransactionIncomeExpenseTypeLabels,
  bankTransactionIncomeExpenseTypeOptions,
} from './bankTransactionIncomeExpenseTypeLabels';

type BankTransactionIncomeExpenseTypeEditCellProps = {
  value: unknown;
  onValueChange: (value: number) => void;
  onRowValueChange?: (patch: Record<string, unknown>) => void;
};

export const BankTransactionIncomeExpenseTypeEditCell = ({
  value,
  onValueChange,
  onRowValueChange,
}: BankTransactionIncomeExpenseTypeEditCellProps) => {
  const numericValue = Number(value);
  const selectedValue = bankTransactionIncomeExpenseTypeLabels[numericValue]
    ? numericValue
    : undefined;

  return (
    <CustomDropdown
      options={bankTransactionIncomeExpenseTypeOptions}
      value={selectedValue}
      onChange={(nextValue) => {
        if (nextValue === undefined) return;

        if (nextValue === numericValue) return;

        onValueChange(nextValue);
        onRowValueChange?.({
          CrmInvoiceId: null,
          CrmIncomeExpenseCategoryId: null,
        });
      }}
      showAllOption={false}
      placeholder="Select type"
    />
  );
};
